import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    siteKey: String
  }

  connect() {
    this.renderWidget()
  }

  disconnect() {
    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }

  renderWidget() {
    if (!window.turnstile || !this.siteKeyValue) return

    if (this.widgetId) {
      window.turnstile.remove(this.widgetId)
    }

    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.siteKeyValue,
      theme: "light",
      size: "normal"
    })
  }
}
